import React, { useContext } from "react";
import { makeStyles } from "tss-react/mui";
import { primaryColor } from "assets/jss/xrs.js";
import { useSelector } from "react-redux";
import Iframe from "react-iframe";
import HeaderSectionLoggedID from "../SectionsPage/Sections/HeaderSectionLoggedID.js";
import BlueHeader from "../SectionsPage/Sections/BlueHeaderSection.js";
import Context from "../../utils/context";
import { Box } from "@mui/material";
const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent) ||
  window.matchMedia("(max-width: 768px)").matches;

let drawerWidth = 150;
if (isMobile) {
  drawerWidth = 0;
}
const useStyles2 = makeStyles()((theme) => ({
  content: {
    padding: theme.spacing(3),

    paddingTop: 60,
    paddingBottom: 38,
    flexGrow: 1,
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: 0,
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
  },
  Iframecontainer: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    paddingTop: "56.25%" /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */,
  },

  /* Then style the iframe to fit in the container div with full height and width */
  responsiveIframe: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    height: "100%",
  },
}));

export default function IframePage(props) {
  const { classes: classes2, cx } = useStyles2();
  const context = useContext(Context);
  const [page, setPage] = React.useState(1);
  const url = useSelector((state) => state.SiteReducer.iframeUrl);

  return (
    <Box component="div" sx={{ backgroundColor: primaryColor[14] }}>
      <main
        className={cx(classes2.content, {
          [classes2.contentShift]: context.stateDrawer,
        })}
      >
        <HeaderSectionLoggedID
          page="iframe"
          title="iframe"
        ></HeaderSectionLoggedID>
        <BlueHeader></BlueHeader>
        <div className={classes2.Iframecontainer}></div>
        <Iframe className={classes2.responsiveIframe} src={url}>
          IframePage
        </Iframe>{" "}
      </main>
    </Box>
  );
}
